export const load = () => ({
	title: 'Beat the Heat and Save Money with Indow Window Inserts',
	showTitle: false,
	breadcrumbs: false,
});
